{
  "name": "swd-web",
  "version": "1.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --o",
    "start:dev": "ng serve --o --configuration=dev",
    "start:test": "ng serve --o --configuration=test",
    "start:prod": "ng serve --o --configuration=prod",
    "build": "ng build",
    "build:dev": "ng build --configuration=dev",
    "build:test": "ng build --configuration=test",
    "build:prod": "ng build --configuration=prod --stats-json",
    "watch": "ng build --watch --configuration local",
    "test": "ng test --watch=false",
    "test:watch": "ng test",
    "test:ci": "ng test --watch=false",
    "test:cov": "powershell -NoProfile -Command \"ng test 2>&1 | Select-String 'All files|% Stmts'\"",
    "lint": "eslint \"src/**/*.{ts,html}\"",
    "lint:fix": "prettier --write \"src/**/*.{ts,html,scss,css,json}\" && eslint \"src/**/*.{ts,html}\" --fix",
    "format": "prettier --write \"src/**/*.{ts,html,scss,css,json}\"",
    "e2e": "playwright test",
    "e2e:ci": "playwright test",
    "e2e:auth": "playwright test --project=setup-admin",
    "e2e:auth:user": "playwright test --project=setup-user",
    "e2e:auth:all": "playwright test --project=setup-admin --project=setup-user",
    "e2e:ui": "playwright test --ui",
    "e2e:headed": "playwright test --headed",
    "e2e:nonheadless": "playwright test --headed"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "21.2.25",
    "@angular/common": "21.2.25",
    "@angular/compiler": "21.2.25",
    "@angular/core": "21.2.25",
    "@angular/forms": "21.2.25",
    "@angular/platform-browser": "21.2.25",
    "@angular/platform-browser-dynamic": "21.2.25",
    "@angular/router": "21.2.25",
    "@azure/msal-angular": "^4.0.26",
    "@azure/msal-browser": "^4.28.2",
    "@microsoft/applicationinsights-web": "^3.4.1",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@primeuix/themes": "^2.0.3",
    "primeicons": "^7.0.0",
    "primeng": "^21.1.5",
    "rxjs": "~7.8.0",
    "tslib": "^2.8.1"
  },
  "devDependencies": {
    "@angular-eslint/eslint-plugin": "^21.3.1",
    "@angular-eslint/eslint-plugin-template": "^21.3.1",
    "@angular-eslint/template-parser": "^21.3.1",
    "@angular/build": "^21.2.19",
    "@angular/cli": "^21.2.19",
    "@angular/compiler-cli": "21.2.25",
    "@azure/identity": "^4.13.1",
    "@azure/identity-vscode": "^2.2.0",
    "@azure/keyvault-secrets": "^4.11.1",
    "@eslint/js": "^10.0.1",
    "@playwright/test": "^1.55.0",
    "@types/node": "^24.6.0",
    "@vitest/coverage-v8": "^4.0.0",
    "eslint": "^10.2.0",
    "eslint-config-prettier": "^10.1.8",
    "jsdom": "^26.0.0",
    "prettier": "^3.7.4",
    "typescript": "~5.9.2",
    "typescript-eslint": "^8.58.1",
    "vitest": "^4.0.0"
  },
  "engines": {
    "node": "24.11.1"
  },
  "overrides": {
    "uuid": "^14.0.0",
    "postcss": "^8.5.18",
    "esbuild": "0.28.1",
    "vite": "^8.0.0",
    "webpack-dev-server": "^5.2.6",
    "less": "^4.2.0",
    "piscina": "5.3.2",
    "@angular/build": {
      "undici": "7.29.1"
    },
    "@angular/cli": {
      "@modelcontextprotocol/sdk": "1.31.0"
    }
  }
}
